// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-be6b7bae]:export {\n  menuText: #bfcbd9;\n  menuActiveText: #2b9ef7;\n  subMenuActiveText: #f4f4f5;\n  menuBg: #000f29;\n  menuHover: rgba(38, 158, 247, 0.7);\n  subMenuBg: #000;\n  subMenuHover: rgba(38, 158, 247, 0.7);\n  sideBarWidth: 210px;\n  primaryColor: #2b9ef7;\n}\n.scroll-container[data-v-be6b7bae] {\n  white-space: nowrap;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
